import * as Yup from "yup";

export const validationSchema = Yup.object({
  name: Yup.string("Enter your name").required("Name is required"),
  email: Yup.string("Enter your email").email("Enter a valid email").required("Email is required"),
  mobile_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits!")
    .required("Mobile number is required!"),
  address: Yup.string("Enter your address").required("Address is required"),
  logo: Yup.string("Upload a logo").required("Image is required"),
  announcement: Yup.string("Enter an announcement"),
  instagram_link: Yup.string("Enter Instagram link"),
  youtube_link: Yup.string("Enter YouTube link"),
  facebook_link: Yup.string("Enter Facebook link"),
  twitter_link: Yup.string("Enter Twitter link"),
});
